module.exports = __webpack_public_path__ + "static/media/sbk.5ec3d78a.JPG";